import { DEFAULT_TIME_TO_CLOSE_CHECKIN } from '../constants/terminal'

export interface OriginTerminal {
  id: string
  info: string
  location: string
  state: string
  firstInstruction: string
  secondInstruction: string
  allowReprint: boolean
  allowVehicleCardPrint: boolean
  checkInClosingOffset: number
}
export interface Lang {
  [index: string]: string
}
export interface Terminal {
  id: string
  info: string
  location: string
  state: string
  firstInstruction: Lang
  secondInstruction: Lang
  allowReprint: boolean
  allowVehicleCardPrint: boolean
  checkInClosingOffset: number
}

const listOfLangs: Lang = { en: 'en', ru: 'ru', et: 'et', fi: 'fi', sv: 'sv', lv: 'lv', pl: 'pl' }

export const composeTerminal = (data: Terminal | null) => {
  const composeInstruction = (instruction: Lang) => {
    return Object.keys(listOfLangs).reduce((acc, lang) => {
      return { ...acc, [lang]: (instruction && instruction[lang] && instruction[lang]) || '' }
    }, {})
  }
  const firstInstruction = (data && composeInstruction(data.firstInstruction)) || {}
  const secondInstruction = (data && composeInstruction(data.secondInstruction)) || {}
  return {
    id: (data && data.id) || '',
    info: (data && data.info) || '',
    location: (data && data.location) || '',
    state: (data && data.state) || '',
    firstInstruction,
    secondInstruction,
    allowReprint: (data && !!data.allowReprint) || false,
    allowVehicleCardPrint: (data && !!data.allowVehicleCardPrint) || false,
    checkInClosingOffset: (data && data.checkInClosingOffset) || DEFAULT_TIME_TO_CLOSE_CHECKIN,
  }
}

export const composeTerminals = (data: any) => {
  const terminals = (data && data.length > 0 ? data : [{}]).map((terminalData: any = {}) => {
    return composeTerminal(terminalData)
  })
  return terminals
}
